import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { BatchJobParameter } from '../batch-job-detail/batch-job-parameter.model';

@Injectable({
  providedIn: 'root',
})
export class BatchJobScheduleParameterApi extends RestApi<BatchJobParameter> {
  override endpoint = '/api/admin/batchjobscheduleparameters';
}
